import { $window } from './bom';

/**
 * @desc 获取 url 中的参数
 * @param name
 * @param url
 * @see http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
export function getQueryString(name: string, url?: string) {
    if (!url) {
        url = $window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return results[2].replace(/\+/g, ' ');
}

/**
 * Add / Update a key-value pair in the URL query parameters
 * @param uri
 * @param key
 * @param value
 */
export function updateUrlParameter(uri: string, key: string | any, value: string = '') {
    // remove the hash part before operating on the uri
    const i = uri.indexOf('#');
    const hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    if (typeof key === 'object') {
        const map = key as { [key: string]: string };
        for (key in map) {
            if (map.hasOwnProperty(key)) {
                value = map[key];
                if (typeof value !== 'undefined') {
                    uri = updateUrlParameter(uri, key, value);
                }
            }
        }
    } else {
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            uri = uri + separator + key + '=' + encodeURIComponent(value);
        }
    }

    return uri + hash; // finally append the hash as well
}

const isPlainObject = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object Object]';
};

export const addQueryString = (url: string, param: { [key: string]: any }) => {
    if (!isPlainObject(param)) {
        return url;
    }
    let hasFirstParam = /\?/.test(url);
    for (const key in param) {
        if (Object.prototype.hasOwnProperty.call(param, key) && param[key] !== undefined) {
            const value = param[key];
            url += `${hasFirstParam ? '&' : '?'}${key}=${value}`;
            hasFirstParam = true;
        }
    }
    return url;
};
